var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175px",
    height: "175px",
    viewBox: "0 0 175 175",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chart/icon/horizontal-bar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart/icon/horizontal-bar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(24.000000, 20.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#243B81",
    transform: "translate(50.000000, 6.500000) rotate(90.000000) translate(-50.000000, -6.500000) ",
    x: 44,
    y: -43,
    width: 12,
    height: 99,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#243B81",
    transform: "translate(44.000000, 24.500000) rotate(90.000000) translate(-44.000000, -24.500000) ",
    x: 38,
    y: -19,
    width: 12,
    height: 87,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#F5A623",
    transform: "translate(15.000000, 43.000000) rotate(90.000000) translate(-15.000000, -43.000000) ",
    x: 9,
    y: 29,
    width: 12,
    height: 28,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#243B81",
    transform: "translate(27.000000, 59.000000) rotate(90.000000) translate(-27.000000, -59.000000) ",
    x: 21,
    y: 33,
    width: 12,
    height: 52,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#BEC753",
    transform: "translate(17.000000, 77.500000) rotate(90.000000) translate(-17.000000, -77.500000) ",
    x: 11,
    y: 61,
    width: 12,
    height: 33,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#F5A623",
    transform: "translate(40.000000, 94.500000) rotate(90.000000) translate(-40.000000, -94.500000) ",
    x: 34,
    y: 55,
    width: 12,
    height: 79,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#BEC753",
    transform: "translate(64.000000, 112.500000) rotate(90.000000) translate(-64.000000, -112.500000) ",
    x: 58,
    y: 49,
    width: 12,
    height: 127,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#D8D8D8",
    transform: "translate(25.000000, 129.000000) rotate(90.000000) translate(-25.000000, -129.000000) ",
    x: 19,
    y: 105,
    width: 12,
    height: 48,
    rx: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBar);
export default __webpack_public_path__ + "static/media/horizontal-bar.39b442b13adb9de1211d941acd6d3168.svg";
export { ForwardRef as ReactComponent };